import React, { memo } from 'react';

import MaterialTextField from '../MaterialTextField/MaterialTextField';
import { useTimeField } from './useTimeField';

export const TimeField = memo((props) => {
    const { errorText, label, name, className, disabled, hintText, fullWidth = true, required, defaultValue, onEditField } = props;
    const { value, customHelperText, handleBlur, handleChange, handleFocus } = useTimeField(errorText, required, defaultValue, onEditField);

    return (
        <MaterialTextField
            autoComplete="off"
            placeholder={hintText || label}
            {...{ label, name, value, disabled, fullWidth, className }}
            helperText={customHelperText}
            error={Boolean(errorText)}
            onBlur={handleBlur}
            onFocus={handleFocus}
            onChange={handleChange}
            key={name}
        />
    );
});

TimeField.displayName = 'TimeField';
